import { combineReducers } from 'redux'

import appReducer from './app/reducer'
import catalogueReducer from './catalogueManagement/reducer'
import dataVisualization from './dataVisualization/reducer'
import jobsReducer from './jobs/reducer'
import userReducer from './user_management/reducer'
import { LOGOUT } from './user_management/types'
import { isEqual } from '../utils/javascript'

const rootReducer = combineReducers({
  app: appReducer,
  user: userReducer,
  dataVisualization,
  catalogue: catalogueReducer,
  jobs: jobsReducer,
})

const reducer = (state, action) => {
  if (isEqual(action.type, LOGOUT)) {
    state = undefined
  }
  return rootReducer(state, action)
}

export default reducer
